import { AuthState, MutationClass } from '../../../models';

export class ClearModuleMutation implements MutationClass {

  public static execute(state: AuthState): void {
    Object.assign(state, {
      token: undefined,
      refreshToken: undefined,
      keepLoggedIn: false
    });
  }

}
